import api from "../../../components/axiosComp";

// GET: list admins assigned to a specific venue
export async function listAssignedVenueAdmins(venueId) {
  const { data } = await api.get(`/api/superAdmin/venues/${venueId}/admins`);
  // Accept {admins:[...]} OR {items:[...]} OR raw array
  const raw = Array.isArray(data?.admins)
    ? data.admins
    : Array.isArray(data?.items)
      ? data.items
      : Array.isArray(data)
        ? data
        : [];

  // Normalize each entry to { staff: {...}, assignedAt?: string }
  return raw.map((x) =>
    x && x.staff
      ? x
      : {
          staff: x,
          assignedAt: x?.assignedAt || x?.createdAt || null,
        },
  );
}

// POST: create a new venue_admin, then assign to the venue
export async function createAndAssignVenueAdmin(
  venueId,
  { name, email, password, venueId: explicitVenueId } = {},
) {
  const payload = { name, email, password };
  // Forward venueId from either the function arg or the object
  const vId = String(explicitVenueId || venueId || "");
  if (vId) payload.venueId = vId;

  const createResp = await api.post(`/api/superAdmin/admins`, payload);

  const staffId = createResp?.data?.admin?._id;
  if (!staffId) throw new Error("Failed to create admin");

  // Keep the second call for idempotent linking (safe even if BE already set it)
  await api.post(`/api/superAdmin/venues/${venueId}/admins`, { staffId });
  return { staffId };
}


// POST: assign an existing venue_admin to the venue
export async function assignExistingVenueAdmin(venueId, staffId) {
  await api.post(`/api/superAdmin/venues/${venueId}/admins`, { staffId });
}

// DELETE: unassign a venue_admin from the venue
export async function unassignVenueAdmin(venueId, staffId) {
  const { data } = await api.delete(
    `/api/superAdmin/venues/${venueId}/admins/${staffId}`,
  );
  return data;
}

// GET: list all venue_admins (for "Assign Existing" dropdown/search)
export async function listAllVenueAdmins({ q = "", active = true } = {}) {
  const { data } = await api.get(`/api/superAdmin/admins`, {
    params: { q, active },
  });
  return Array.isArray(data?.admins) ? data.admins : [];
}

export async function updateVenueAdmin(staffId, payload) {
  const { data } = await api.patch(
    `/api/superAdmin/admins/${staffId}`,
    payload,
  );
  return data?.admin;
}
